module.exports = __webpack_public_path__ + "static/JPEG image 147-82b6984ea6b0ec24a270f529a9eae668.jpeg";